document.addEventListener("DOMContentLoaded", () => {

   const swatchContentContainers = document.querySelectorAll('.swatch-content');

if (swatchContentContainers.length === 0) {
  // Nothing to do
  return;
}

swatchContentContainers.forEach(container => {
  const baseUrl = container.querySelector('.producturl')?.textContent;
  if (!baseUrl) return;

  const firstArray = Array.from(
    container.querySelectorAll('.swatches-object p')
  ).map(p => p.textContent.toLowerCase());

  const colorRow = container.querySelector('.color-row');
  if (!colorRow) return;

  const colorArray2 = colorRow.textContent
    .split(',')
    .filter(Boolean);

  const keywords = colorArray2.flatMap(color =>
    color.toLowerCase().split(' ')
  );

  const resultArray = firstArray.filter(
    item => !keywords.includes(item.toLowerCase())
  );

  const result = resultArray
    .join(' ')
    .toLowerCase()
    .replace(/\s+/g, '-');

  container.querySelectorAll('.anchorproduct').forEach(anchor => {
    const span = anchor.querySelector('span');
    if (!span) return;

    const color = span
      .getAttribute('data-color')
      ?.toLowerCase()
      .replace(/\s+/g, '-');

    if (!color) return;

    anchor.href = `/products/${result}-${color}`;

    if (baseUrl === `${result}-${color}`) {
      anchor
        .closest('li.color-swatch')
        ?.classList.add('current-color');
    }
  });
});



});
